import {
	GetInactivePlyerRequest,
	GetInactivePlayerResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getInactivePlayerList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetInactivePlayer(
	payload: GetInactivePlyerRequest,
	props?: UseBaseQueryOptions<GetInactivePlayerResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetInactivePlayerList, payload],
		queryFn: () => getInactivePlayerList(payload),
		...props,
	})
}
